// extracted by mini-css-extract-plugin
export default {"Grabber":"I9Aq5","grabbing":"HH4ED"};